var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 -0.000976562C16.5237 -0.000976562 21.0015 4.47687 21.0015 10.0006C21.0015 15.5243 16.5237 20.0021 11 20.0021C5.47626 20.0021 0.998413 15.5243 0.998413 10.0006C0.998413 4.47687 5.47626 -0.000976562 11 -0.000976562ZM11 1.49902C6.30469 1.49902 2.49841 5.3053 2.49841 10.0006C2.49841 14.6959 6.30469 18.5021 11 18.5021C15.6952 18.5021 19.5015 14.6959 19.5015 10.0006C19.5015 5.3053 15.6952 1.49902 11 1.49902ZM10.9963 8.4996C11.376 8.4994 11.69 8.7813 11.7399 9.1473L11.7468 9.2491L11.7504 14.7507C11.7507 15.1649 11.4151 15.5009 11.0009 15.5012C10.6212 15.5014 10.3072 15.2195 10.2573 14.8535L10.2504 14.7517L10.2468 9.2501C10.2465 8.8359 10.5821 8.4999 10.9963 8.4996ZM11.0004 5.00184C11.552 5.00184 11.9991 5.44896 11.9991 6.0005C11.9991 6.55205 11.552 6.99917 11.0004 6.99917C10.4489 6.99917 10.0017 6.55205 10.0017 6.0005C10.0017 5.44896 10.4489 5.00184 11.0004 5.00184Z",
    fill: "#4D5F70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.943bc82acbcaf454d3299e05e6d8c5f1.svg";
export { ForwardRef as ReactComponent };